module.exports = __webpack_public_path__ + "static/gm-38-4a1d2506f2aa2a52694b30b32d8fb0fa.jpg";